import TableViewConversationRelation from 'mini-mail-list-store/lib/store/schema/TableViewConversationRelation';

/**
 * Utility function to tell whether a mail conversation has an attachment or not
 * @param tableConversationRelation, which has the hasAttachment key to notify whether the mail item has an attachment or not
 */
export default function getHasAttachment(
    tableConversationRelation: TableViewConversationRelation
): boolean {
    return tableConversationRelation.hasAttachments;
}
